// ============================================================================
// Territory Types and Constants
// ============================================================================
export const TerritoryType = {
    HOME: 0, // Invulnerable, 1 per player, 15x15 tiles
    OUTPOST: 1, // Raidable, unlimited, 10x10 tiles
};
// Territory radii (tiles from center)
export const TERRITORY_RADIUS = {
    [TerritoryType.HOME]: 7, // 15x15 area
    [TerritoryType.OUTPOST]: 5, // 10x10 area (actually 11x11 with center)
};
// Minimum distance from home to place outpost
export const MIN_OUTPOST_DISTANCE_FROM_HOME = 50;
// Maximum storage containers in home territory
export const HOME_STORAGE_LIMIT = 5;
// Check if a position is within a territory
export const isPositionInTerritory = ({ x, y, territory, }) => {
    const dx = Math.abs(x - territory.centerX);
    const dy = Math.abs(y - territory.centerY);
    return dx <= territory.radius && dy <= territory.radius;
};
// Get distance between two points
export const getDistance = ({ x1, y1, x2, y2, }) => {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return Math.sqrt(dx * dx + dy * dy);
};
//# sourceMappingURL=types.js.map